window.Products.Clothing.CrewneckSweatshirt = function() {
};
window.Products.Clothing.CrewneckSweatshirt.inherits(window.Products.Clothing.Shirt);
window.Products.Clothing.CrewneckSweatshirt.dpi = 150;
window.Products.Clothing.CrewneckSweatshirt.has_3d = true;
window.Products.Clothing.CrewneckSweatshirt.id = 88;
window.Products.Clothing.CrewneckSweatshirt.slug = 'crewneck-sweatshirt';
window.Products.Clothing.CrewneckSweatshirt.syncColors = true;
window.Products.Clothing.CrewneckSweatshirt.texturesLoaded = 0;
window.Products.Clothing.CrewneckSweatshirt.texturesLoading = false;
window.Products.Clothing.CrewneckSweatshirt.use_glb = true;

window.Products.Clothing.CrewneckSweatshirt.prototype.outsideObject = 0;
window.Products.Clothing.CrewneckSweatshirt.prototype.insideObject = 1;
window.Products.Clothing.CrewneckSweatshirt.prototype.detailsObject = 2;

window.Products.Clothing.CrewneckSweatshirt.prototype.handleColorOption = function(modelViewer, color){
	var me = modelViewer.product;

	var object = modelViewer.object;
	if(!object) return;

	if(!color) {
		if(modelViewer.inlab){
			$('#button_options_color').find('img').attr('src', $(this).find('img').attr('src'));
			$('#container_options_color, #button_options_color').removeClass('active');
			color = $(this).attr('for');
		} else {
			color = $('#productInfo-productOption-color').find('option:selected').attr('data-slug');
		}
	}

	var three_color = me.getColor(color);

	object.children[me.detailsObject].material.color = three_color;
	object.children[me.insideObject].material.color = three_color;

	me.updateThreeTexture(modelViewer);
	var three_intensity = 2.5;

	object.children[me.outsideObject].material.aoMapIntensity = three_intensity;
	object.children[me.insideObject].material.aoMapIntensity = three_intensity;
};

window.Products.Clothing.CrewneckSweatshirt.prototype.getColor = function(_name){
	colors = {
		"white": 0xffffff,
		"black": 0x151515,
		"dark_heather": 0x3f3d47,
		"maroon": 0x6c1e34,
		"navy_blue": 0x262738,
		"sport_grey": 0xa6a3a8
	};

	return new THREE.Color(colors[_name]);
};